// Buy box and "added" panel (Phase 5; views/partials/buybox.php, inc/add-to-basket.php).
//
// Calculator: the floor area and wastage set the boxes (rounded up); the box stepper overrides them. The price is
// boxes × box price, the box price from the basket's own price breaks (data-buybox), so it equals the basket.
// Every form with data-jfj-add (buy box, sample, the panel's suggestions) is sent to ?wc-ajax=jfj_add; the answer
// is the panel's HTML, rendered from the basket, and the header's fragments. Without JS the forms post normally.

var VAT = 0.2;

function money(x) {
    return '£' + x.toLocaleString('en-GB', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

function both(ex) {
    return '<span class="incvat">' + money(Math.round(ex * (1 + VAT) * 100) / 100) + '</span><span class="exvat">' + money(ex) + '</span>';
}

function num(v) {
    var n = parseFloat(String(v || '').replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
}

function round2(x) {
    return Math.round(x * 100) / 100;
}

function m2(x) {
    return String(round2(x));
}

function boxPrice(breaks, boxes) {
    var p = breaks[0][1];
    breaks.forEach(function (b) {
        if (boxes >= b[0]) {
            p = b[1];
        }
    });
    return p;
}

function setupCalculator(form) {
    var d = JSON.parse(form.dataset.buybox);
    var sqm = form.querySelector('[data-sqm]'), qty = form.querySelector('[data-qty]');
    var bar = document.querySelector('[data-buybar]');
    var chosen = false; // the customer set the boxes with the stepper

    function wastage() {
        var w = form.querySelector('[name=jfj_wastage]:checked');
        return w ? +w.value : 0;
    }

    function fromArea() {
        var a = num(sqm && sqm.value);
        if (a > 0) {
            qty.value = Math.max(1, Math.ceil(a * (1 + wastage() / 100) / d.per - 1e-9));
        }
        chosen = false;
        render();
    }

    function render() {
        var boxes = Math.max(1, parseInt(qty.value, 10) || 1);
        var ex = round2(boxes * boxPrice(d.breaks, boxes));
        var unit = boxPrice(d.breaks, boxes);
        var need, asked = '';
        if (d.per > 0) {
            var a = num(sqm.value), w = wastage(), cover = boxes * d.per;
            need = boxes + (boxes === 1 ? ' box covers ' : ' boxes cover ') + m2(cover) + ' m²';
            if (!a) {
                asked = 'Enter your floor area, or choose the boxes';
            } else if (chosen) {
                asked = 'You chose the boxes. Your floor area is ' + m2(a) + ' m²';
            } else {
                asked = m2(a) + ' m² + ' + w + '% wastage = ' + m2(a * (1 + w / 100)) + ' m²';
            }
            form.querySelector('[data-unit]').innerHTML = both(unit) + ' per box, ' + both(round2(unit / d.per)) + ' per m²';
            if (bar) {
                bar.querySelector('[data-bar-total]').innerHTML = both(ex);
                bar.querySelector('[data-bar-need]').textContent = boxes + (boxes === 1 ? ' box · ' : ' boxes · ') + m2(cover) + ' m²';
            }
        } else {
            need = boxes + ' × ' + (document.querySelector('.product-details h2') || {textContent: ''}).textContent.trim();
            form.querySelector('[data-unit]').innerHTML = both(unit) + ' each';
        }
        form.querySelector('[data-need]').textContent = need;
        form.querySelector('[data-asked]').textContent = asked;
        form.querySelector('[data-total]').innerHTML = both(ex);
    }

    if (sqm) {
        // m² carried over from the calculator page (its own script sets the sqm cookie).
        var c = document.cookie.match(/(?:^|; )sqm=([^;]*)/);
        if (c && num(decodeURIComponent(c[1]))) {
            sqm.value = decodeURIComponent(c[1]);
            fromArea();
        }
        sqm.addEventListener('input', fromArea);
        form.querySelectorAll('[name=jfj_wastage]').forEach(function (r) {
            r.addEventListener('change', fromArea);
        });
    }
    form.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
            qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.dataset.step));
            chosen = true;
            render();
        });
    });
    qty.addEventListener('input', function () {
        chosen = true;
        render();
    });
    render();

    // Phone bar: shown while the buy box's button is off screen, above or below (space kept below the page so
    // nothing moves).
    if (bar && 'IntersectionObserver' in window) {
        var add = form.querySelector('[data-add]');
        document.body.classList.add('has-buybar');
        new IntersectionObserver(function (es) {
            bar.hidden = es[0].isIntersecting;
        }).observe(add);
        bar.querySelector('[data-bar-add]').addEventListener('click', function () {
            add.click();
        });
    }
}

var panel, backdrop, opener;

function closePanel() {
    if (!panel || panel.hidden) {
        return;
    }
    panel.hidden = true;
    backdrop.hidden = true;
    if (opener && document.contains(opener)) {
        opener.focus({preventScroll: true});
    }
}

function showPanel(html, from) {
    panel.innerHTML = html;
    panel.hidden = false;
    backdrop.hidden = false;
    opener = from;
    var h = panel.querySelector('h2');
    if (h) {
        h.focus({preventScroll: true});
    }
}

function applyFragments(frags) {
    Object.keys(frags || {}).forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
            el.outerHTML = frags[sel];
        });
    });
}

function send(form, button) {
    var body = new FormData(form);
    // As product_id: a POSTed add-to-cart is also picked up by WooCommerce's own form handler, which would add it
    // first and redirect (that field is for the plain post without JS).
    body.set('product_id', body.get('add-to-cart'));
    body.delete('add-to-cart');
    if (button) {
        button.disabled = true;
        button.classList.add('is-busy');
    }
    var url = (window.wc_add_to_cart_params && wc_add_to_cart_params.wc_ajax_url) || '/?wc-ajax=%%endpoint%%';
    return fetch(url.replace('%%endpoint%%', 'jfj_add'), {method: 'POST', body: body, credentials: 'same-origin'})
        .then(function (r) {
            if (!r.ok) {
                throw new Error(r.status);
            }
            return r.json();
        })
        .then(function (res) {
            applyFragments(res.fragments);
            showPanel(res.panel, button);
            if (res.ok && window.jQuery) {
                // WooCommerce's own event after an AJAX add, which tracking plugins listen for. No button: given one,
                // WooCommerce's handler puts its own "View basket" link after it.
                jQuery(document.body).trigger('added_to_cart', [res.fragments, res.cart_hash, jQuery()]);
            }
        })
        .catch(function () {
            form.submit(); // fall back to the plain form post
        })
        .finally(function () {
            if (button) {
                button.disabled = false;
                button.classList.remove('is-busy');
            }
        });
}

export function initBuybox() {
    panel = document.getElementById('jfj-added');
    backdrop = document.querySelector('.added-backdrop');
    document.querySelectorAll('[data-buybox]').forEach(setupCalculator);
    if (!panel) {
        return;
    }
    // One listener for every add form, the panel's own suggestions included (they arrive with the panel).
    document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-jfj-add]');
        if (!form || !window.fetch) {
            return;
        }
        e.preventDefault();
        send(form, e.submitter || form.querySelector('[type=submit]'));
    });
    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-added-close]')) {
            closePanel();
        } else if (!panel.hidden && !panel.contains(e.target) && !e.target.closest('[data-jfj-add],[data-bar-add]')) {
            closePanel();
        }
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closePanel();
        }
    });
}
